import axios from '../plugins/axios'

export default {
  changeLanguageInOptionAxios (local) {
    Object.assign(axios.defaults, {headers: {'App-Locale': local}})
  },
  setTokenInOptionAxios(token){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  },
  setTokenWithoutBearerInOptionAxios(token){
    axios.defaults.headers.common['Authorization'] = token
  },
  removeTokenInOptionAxios(){
    axios.defaults.headers.common['Authorization'] = ''
  }
}


// WEBPACK FOOTER //
// ./src/Unit/change-axios-header.js